export var ContentstackTagEnum;
(function (ContentstackTagEnum) {
    ContentstackTagEnum["ClimateSource"] = "cs";
    ContentstackTagEnum["Mf"] = "mf";
    ContentstackTagEnum["PowerSource"] = "ps";
    ContentstackTagEnum["Semikron"] = "sdw";
    ContentstackTagEnum["Source"] = "source";
})(ContentstackTagEnum || (ContentstackTagEnum = {}));
//# sourceMappingURL=tag.js.map